/*
* Pipeline Theme
*
* Custom code for size selection overlay
*/

(function() {
  'use strict';

  // Track if user has actively selected a variant option
  let variantActivelySelected = false;

  // Initialize when DOM is ready
  function init() {
    const productForms = document.querySelectorAll('[data-product-form]');
    
    productForms.forEach(form => {
      setupVariantSelection(form);
      setupFormSubmission(form);
    });
  }

  // Setup variant selection tracking
  function setupVariantSelection(form) {
    const variantInputs = form.querySelectorAll('input[name^="options["]');
    const variantSelects = form.querySelectorAll('select[name^="options["]');
    
    // Only mark as selected if variant was explicitly chosen via URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const hasVariantInUrl = urlParams.has('variant');
    
    if (hasVariantInUrl) {
      variantActivelySelected = true;
      const formHolder = form.closest('[data-form-holder]');
      if (formHolder) {
        formHolder.setAttribute('data-variant-selected', 'true');
      }
    } else {
      // On page load, uncheck all radio/checkbox inputs to prevent auto-selection
      variantInputs.forEach(input => {
        if (input.checked) {
          input.checked = false;
        }
      });
    }

    // Track when user actively clicks/changes variant (radio buttons/checkboxes)
    variantInputs.forEach(input => {
      input.addEventListener('change', function() {
        variantActivelySelected = true;
        const formHolder = form.closest('[data-form-holder]');
        if (formHolder) {
          formHolder.setAttribute('data-variant-selected', 'true');
        }
      });
    });

    // Track when user actively changes variant (dropdowns)
    variantSelects.forEach(select => {
      select.addEventListener('change', function() {
        variantActivelySelected = true;
        const formHolder = form.closest('[data-form-holder]');
        if (formHolder) {
          formHolder.setAttribute('data-variant-selected', 'true');
        }
      });
    });

    // Also track clicks on popout select options (custom dropdowns)
    const popoutOptions = form.querySelectorAll('[data-popout-option]');
    popoutOptions.forEach(option => {
      option.addEventListener('click', function() {
        variantActivelySelected = true;
        const formHolder = form.closest('[data-form-holder]');
        if (formHolder) {
          formHolder.setAttribute('data-variant-selected', 'true');
        }
      });
    });
  }

  // Setup form submission with validation
  function setupFormSubmission(form) {
    const addToCartButton = form.querySelector('[data-add-to-cart]');
    if (!addToCartButton) return;

    // Create overlay element
    const overlay = createOverlay(form);


    const buttonWrapper = addToCartButton.closest('[data-add-action-wrapper]');
    if (buttonWrapper && !buttonWrapper.querySelector('.size-selection-overlay')) {
      buttonWrapper.style.position = 'relative';
      buttonWrapper.appendChild(overlay);
    }

    // Intercept form submission
    form.addEventListener('submit', function(e) {
      const formHolder = form.closest('[data-form-holder]');
      const hasMultipleVariants = form.querySelectorAll('input[name^="options["]').length > 0;
      
      // Only validate if product has variants and none selected yet
      if (hasMultipleVariants && !variantActivelySelected && 
          (!formHolder || formHolder.getAttribute('data-variant-selected') !== 'true')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        showOverlayMessage(overlay);
        return false;
      }
    }, true); // Use capture phase to intercept before Alpine.js
  }

  // Create overlay element
  function createOverlay(form) {

   const addToCartButton = form.querySelector('[data-add-to-cart]');
  if (!addToCartButton) return;
const variantInputs = document.querySelectorAll('.product__block__variants input[name^="options["]');
const variantSelects = document.querySelectorAll('.product__block__variants select[name^="options["]');


  const hasSizeOptions =
    [...variantInputs].some(el => el.name.includes('Choose your ring size')) ||
    [...variantSelects].some(el => el.name.includes('Choose your ring size'));

  if (!hasSizeOptions) return;

    const overlay = document.createElement('div');
    overlay.className = 'size-selection-overlay';
    overlay.innerHTML = `
      <div class="size-selection-overlay__content">
        <div class="size-selection-overlay__icon">⚠️</div>
        <div class="size-selection-overlay__message">Please select options</div>
      </div>
    `;
    
    overlay.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      showOverlayMessage(overlay);
    });
    
    return overlay;
  }

  // Show overlay message with animation
  function showOverlayMessage(overlay) {
    const content = overlay.querySelector('.size-selection-overlay__content');
    if (content) {
      content.classList.add('shake');
      setTimeout(() => {
        content.classList.remove('shake');
      }, 500);
    }
    
    // Scroll to variant selector and show error message
    const variantSelector = document.querySelector('.product__block__variants');
    if (variantSelector) {
      variantSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      // Remove any existing error message
      const existingError = variantSelector.querySelector('.size-selection-error');
      if (existingError) {
        existingError.remove();
      }
      
      // Create and add error message
      const errorMessage = document.createElement('div');
      errorMessage.className = 'size-selection-error';
      errorMessage.innerHTML = ' Please select your ring size before adding to cart';
      variantSelector.appendChild(errorMessage);
      
      // Trigger animation
      setTimeout(() => {
        errorMessage.classList.add('show');
      }, 10);
      
      // Remove after 3 seconds
      setTimeout(() => {
        errorMessage.classList.remove('show');
        setTimeout(() => {
          errorMessage.remove();
        }, 300);
      }, 3000);
    }
  }

  // Add CSS styles
  function addStyles() {
    const style = document.createElement('style');
    style.textContent = `
      /* Size Selection Overlay Styles */
      .size-selection-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(250, 250, 250, 0.98) 100%);
        backdrop-filter: blur(3px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        cursor: pointer;
        border-radius: inherit;
        transition: all 0.3s ease;
        border: 2px dashed rgba(0, 0, 0, 0.1);
      }

      .size-selection-overlay:hover {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.99) 0%, rgba(248, 248, 248, 0.99) 100%);
        border-color: rgba(0, 0, 0, 0.15);
      }

      [data-variant-selected="true"] .size-selection-overlay {
        display: none !important;
      }

      .size-selection-overlay__content {
        text-align: center;
        padding: 1.5rem 1rem;
        transition: transform 0.2s ease;
      }

      .size-selection-overlay:hover .size-selection-overlay__content {
        transform: scale(1.05);
      }

      .size-selection-overlay__icon {
        font-size: 2.5rem;
        margin-bottom: 0.75rem;
        animation: pulse 2s ease-in-out infinite;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
      }

      .size-selection-overlay__message {
        font-size: 0.875rem;
        font-weight: 700;
        color: #333;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 1.4;
        text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
      }

      @keyframes pulse {
        0%, 100% {
          transform: scale(1);
          opacity: 1;
        }
        50% {
          transform: scale(1.15);
          opacity: 0.85;
        }
      }

      .shake {
        animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97);
      }

      @keyframes shake {
        0%, 100% { 
          transform: translateX(0) scale(1); 
        }
        10%, 30%, 50%, 70%, 90% { 
          transform: translateX(-8px) scale(1.02); 
        }
        20%, 40%, 60%, 80% { 
          transform: translateX(8px) scale(1.02); 
        }
      }

      /* Ensure button wrapper has relative positioning */
      [data-add-action-wrapper] {
        position: relative;
      }

      /* Smooth transitions for variant selection */
      .product__block__variants {
        transition: all 0.3s ease;
        position: relative;
      }

      /* Size selection error message */
      .size-selection-error {
        position: relative;
        margin-top: 1rem;
        padding: 0.75rem 1rem;
        background: transparent;
        border: 1px solid #eee;
        border-radius: 8px;
        color: #404040;
        font-size: 0.875rem;
        font-weight: 600;
        text-align: center;
            letter-spacing: 1px;
        opacity: 0;
        transform: translateY(-10px);
        transition: all 0.3s ease;
        box-shadow: none;
      }

      .size-selection-error.show {
        opacity: 1;
        transform: translateY(0);
      }

      .size-selection-error__icon {
        display: inline-block;
        margin-right: 0.5rem;
        font-size: 1.2em;
        animation: pulse 1s ease-in-out infinite;
      }

      /* Mobile responsive adjustments */
      @media (max-width: 768px) {
        .size-selection-overlay__icon {
          font-size: 2rem;
        }
        
        .size-selection-overlay__message {
          font-size: 0.75rem;
          letter-spacing: 0.75px;
        }

        .size-selection-error {
          font-size: 0.75rem;
          padding: 0.6rem 0.8rem;
          margin-top: 0.75rem;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // Initialize everything when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      addStyles();
      init();
    });
  } else {
    addStyles();
    init();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });

  // Re-initialize when quick view opens
  document.addEventListener('theme:quickview:open', function() {
    setTimeout(init, 100);
  });

  // Reset variant selection tracking on quick view close
  document.addEventListener('theme:quickview:close', function() {
    variantActivelySelected = false;
  });

  // Watch for dynamically added product forms (MutationObserver)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.matches('[data-product-form]') || node.querySelector('[data-product-form]'))) {
            setTimeout(init, 100);
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
